import CrudRequest from 'Domain/CrudRequest';
import http from '@/support/services/HttpService';

class PayableAccountsRequest extends CrudRequest {
  static baseUrl() {
    return '/v1/financeiro/contaAPagar';
  }

  static manuallyTerminate(payload) {
    return http.patch(`${this.baseUrl()}/realizarBaixa`, payload);
  }
}

export default PayableAccountsRequest;
